var React = require('react');

function ShapeGroup4 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.7","d":"M629.473 691.978C411.424 794.241 440.871 467.7 182.965 615.415C-74.9419 763.13 268.634 313.383 486.683 211.119C704.732 108.855 1142.45 38.624 972.589 245.086C802.728 451.547 847.521 589.714 629.473 691.978Z","fill":"#2A4C7E","key":0}),React.createElement("path",{"opacity":"0.7","d":"M426.737 864.346C402.443 624.418 575.648 27.9335 876.595 379.914C1177.54 731.895 1390.14 524.409 1414.43 764.336C1438.72 1004.26 1141.07 1212.09 941.635 1022.25C742.204 832.402 451.031 1104.27 426.737 864.346Z","fill":"#BEE2F1","key":1}),React.createElement("circle",{"opacity":"0.7","cx":"773.5","cy":"1122.5","r":"101.5","fill":"#BEE2F1","key":2})]);
}

ShapeGroup4.defaultProps = {"width":"1445","height":"1224","viewBox":"0 0 1445 1224","fill":"none"};

module.exports = ShapeGroup4;

ShapeGroup4.default = ShapeGroup4;
